import { useNavigate, useOutletContext } from 'react-router-dom'
import styles from './Home.module.scss'
import ChatMessage from '../ChatMessage'

const tags = [
  { text: 'Get your device repaired' },
  { text: 'Troubleshoot your device' },
  { text: 'Track repair status' },
  { text: 'Find nearby service centres' },
  { text: 'Show my appointment' },
]

const Home = () => {
  const navigate = useNavigate()

  const { setMessageResponse } = useOutletContext()

  const callExternalHandler = (messageResponse) => {
    setMessageResponse(messageResponse)
    navigate('/chat')
  }

  return (
    <div className={styles.container}>
      <div className={styles['title']}>☀️ Hello, Sreevathsa Prabhakar</div>
      <div className={styles['help-text']}>What can I help with?</div>
      <ChatMessage callExternalHandler={callExternalHandler} />
      <div className={styles['tags-container']}>
        {tags.slice(0, 3).map((tag, index) => (
          <div key={index} className={styles['tag-item']}>
            {tag.text}
          </div>
        ))}
      </div>
      <div className={`${styles['tags-container']} mt8`}>
        {tags.slice(3).map((tag, index) => (
          <div key={index} className={styles['tag-item']}>
            {tag.text}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Home
